<div [ngClass]="isMobile === true ? 'notification-wrapper-mobil' : 'notification-wrapper'">
  <colimo-page-header [heading]="'sidenav.alerts'"> </colimo-page-header>
  <mat-card appearance="outlined">
    <mat-tab-group mat-align-tabs="start" [selectedIndex]="selectedTab" class="new-font-family">
      <mat-tab>
        <ng-template mat-tab-label>
          @if (alertsConfigured) {
            <mat-icon class="tab-icon">notification_important</mat-icon>
          }
          @if (!alertsConfigured) {
            <mat-icon class="tab-icon">notifications_off</mat-icon>
          }
          <span>{{ 'sidenav.alerts' | translate }}</span>
        </ng-template>
        <ng-template matTabContent>
          @if(loading) {
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          }
          <table mat-table matTableResponsive [dataSource]="alertUserData.content" class="mat-elevation-z8"
            matSort (matSortChange)="sortEvent($event)">
            <ng-container matColumnDef="alertLevel">
              <th mat-header-cell *matHeaderCellDef></th> <!--{{ 'notification.level' | translate }}-->
              <td mat-cell *matCellDef="let element" [ngClass]="element.alertLevel >= 2000 ? 'red-cell' : 'yellow-cell' ">
                <mat-icon>notification_important</mat-icon>
              </td>
            </ng-container>
            <ng-container matColumnDef="alertLevelFilter">
              <th mat-header-cell *matHeaderCellDef>
                <div class="search-icon-cell">
                  @if (!loading) {
                    <mat-icon>search</mat-icon>
                  } @else {
                    <mat-spinner diameter="24"></mat-spinner>
                  }
                </div>
              </th>
            </ng-container>
            <ng-container matColumnDef="colorName">
              <th mat-header-cell *matHeaderCellDef> {{ 'reports.reportTable.color' | translate }} </th>
              <td mat-cell *matCellDef="let element" [ngClass]="element.readStatus === 0 ? 'bold-text' : ''"> {{element.colorName}} </td>
            </ng-container>
            <ng-container matColumnDef="colorNameFilter">
              <th mat-header-cell *matHeaderCellDef>
                <div class="filter-cell">
                  <input class="filter-input" [class.filter-active]="filters.colorName" placeholder="{{ 'reports.reportTable.color' | translate }}" (input)="filterChanged('colorName', $event)" [value]="filters.colorName ?? ''">
                  @if (filters.colorName) {
                    <mat-icon class="clear-icon" (click)="clearFilter('colorName')">close</mat-icon>
                  }
                </div>
              </th>
            </ng-container>
            <ng-container matColumnDef="productNr">
              <th mat-header-cell *matHeaderCellDef> {{ 'reports.reportTable.product' | translate }} </th>
              <td mat-cell *matCellDef="let element" [ngClass]="element.readStatus === 0 ? 'bold-text' : ''"> {{element.productNr}} </td>
            </ng-container>
            <ng-container matColumnDef="productNrFilter">
              <th mat-header-cell *matHeaderCellDef>
                <div class="filter-cell">
                  <input [disabled]="loading" class="filter-input" [class.filter-active]="filters.productNr" placeholder="{{ 'reports.reportTable.product' | translate }}" (input)="filterChanged('productNr', $event)" [value]="filters.productNr ?? ''">
                  @if (filters.productNr) {
                    <mat-icon class="clear-icon" (click)="clearFilter('productNr')">close</mat-icon>
                  }
                </div>
              </th>
            </ng-container>
            <ng-container matColumnDef="batchNr">
              <th mat-header-cell *matHeaderCellDef> {{ 'reports.reportTable.batch' | translate }} </th>
              <td mat-cell *matCellDef="let element" [ngClass]="element.readStatus === 0 ? 'bold-text' : ''"> {{element.batchNr}} </td>
            </ng-container>
            <ng-container matColumnDef="batchNrFilter">
              <th mat-header-cell *matHeaderCellDef>
                <div class="filter-cell">
                  <input [disabled]="loading" class="filter-input" [class.filter-active]="filters.batchNr" placeholder="{{ 'reports.reportTable.batch' | translate }}" (input)="filterChanged('batchNr', $event)" [value]="filters.batchNr ?? ''">
                  @if (filters.batchNr) {
                    <mat-icon class="clear-icon" (click)="clearFilter('batchNr')">close</mat-icon>
                  }
                </div>
              </th>
            </ng-container>
            <ng-container matColumnDef="line">
              <th mat-header-cell *matHeaderCellDef> {{ 'reports.reportTable.line' | translate }} </th>
              <td mat-cell *matCellDef="let element" [ngClass]="element.readStatus === 0 ? 'bold-text' : ''"> {{element.line}} </td>
            </ng-container>
            <ng-container matColumnDef="lineFilter">
              <th mat-header-cell *matHeaderCellDef>
                <div class="filter-cell">
                  <input [disabled]="loading" class="filter-input" [class.filter-active]="filters.line" placeholder="{{ 'reports.reportTable.line' | translate }}" (input)="filterChanged('line', $event)" [value]="filters.line ?? ''">
                  @if (filters.line) {
                    <mat-icon class="clear-icon" (click)="clearFilter('line')">close</mat-icon>
                  }
                </div>
              </th>
            </ng-container>
            <ng-container matColumnDef="model">
              <th mat-header-cell *matHeaderCellDef> {{ 'reports.reportTable.model' | translate }} </th>
              <td mat-cell *matCellDef="let element" [ngClass]="element.readStatus === 0 ? 'bold-text' : ''"> {{element.model}} </td>
            </ng-container>
            <ng-container matColumnDef="modelFilter">
              <th mat-header-cell *matHeaderCellDef>
                <div class="filter-cell">
                  <input [disabled]="loading" class="filter-input" [class.filter-active]="filters.model" placeholder="{{ 'reports.reportTable.model' | translate }}" (input)="filterChanged('model', $event)" [value]="filters.model ?? ''">
                  @if (filters.model) {
                    <mat-icon class="clear-icon" (click)="clearFilter('model')">close</mat-icon>
                  }
                </div>
              </th>
            </ng-container>
            <ng-container matColumnDef="info">
              <th mat-header-cell *matHeaderCellDef> {{ 'notification.info' | translate }} </th>
              <!-- #433972 for direct link alert new batch deviation to new plot avg compare we need the old batch id but the id should not be displayed so remove it here via substring -->
              <td mat-cell *matCellDef="let element" [ngClass]="element.readStatus === 0 ? 'bold-text' : ''"> {{ (element.typ === 'NBD' && element.info.indexOf(NBD_PREV_BATCH_ID) > -1) ? element.info.substring(0, element.info.indexOf(NBD_PREV_BATCH_ID)) : element.info }} </td>
            </ng-container>
            <ng-container matColumnDef="infoFilter">
              <th mat-header-cell *matHeaderCellDef>
                <div class="filter-cell">
                  <input [disabled]="loading" class="filter-input" [class.filter-active]="filters.info" placeholder="{{ 'notification.info' | translate }}" (input)="filterChanged('info', $event)" [value]="filters.info ?? ''">
                  @if (filters.info) {
                    <mat-icon class="clear-icon" (click)="clearFilter('info')">close</mat-icon>
                  }
                </div>
              </th>
            </ng-container>
            <ng-container matColumnDef="createdAt">
              <th mat-header-cell *matHeaderCellDef> {{ 'notification.createdAt' | translate }} </th>
              <td mat-cell *matCellDef="let element" [ngClass]="element.readStatus === 0 ? 'bold-text' : ''"> {{element.createdAt | date: 'yyyy-MM-dd HH:mm' }} </td>
            </ng-container>
            <ng-container matColumnDef="linkToPlot">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element" class="action-cell" (click)="routeToAlertDetails(element)" matTooltip="{{ 'notification.linkTooltip' | translate }}">
                <mat-icon>open_in_new</mat-icon>
              </td>
            </ng-container>
            <ng-container matColumnDef="hideAlert">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element" class="red-cell action-cell" (click)="markAsHidden(element.alertId); $event.stopPropagation()" matTooltip="{{ 'notification.deleteTooltip' | translate }}">
                <mat-icon>delete_forever</mat-icon>
              </td>
            </ng-container>

            <!--<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr> only search line should be displayed right now-->
            <tr mat-header-row *matHeaderRowDef="filterColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="markAsRead(row)"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                {{ 'notification.noData' | translate }}
              </td>
            </tr>
          </table>
          <mat-paginator [pageSizeOptions]="pageSizeOptions"
            [pageSize]="pageSize"
            [length]="totalSize"
            [pageIndex]="currentPage"
            (page)="pageEvent($event)"
            showFirstLastButtons
            aria-label="Select page of periodic elements">
          </mat-paginator>
          <button mat-raised-button class="read-button"
            [disabled]="!alertUserData || !alertUserData.content || alertUserData.content.length < 1"
            matTooltip="{{ 'notification.allReadTooltip' | translate }}"
            (click)="markAllAsRead()"
            color="primary">{{ 'notification.allRead' | translate }}
          </button>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">settings</mat-icon>
          <span>{{ 'notification.configuration' | translate }}</span>
        </ng-template>
        <ng-template matTabContent>
          <div [ngClass]="isMobile === true ? '' : 'kpi-warnings-wrapper'">
            <table mat-table>
              <ng-container matColumnDef="KPIs">
                <th mat-header-cell [colSpan]="4" *matHeaderCellDef>
                  <div class="kpi-warning-label kpi-warning-header">{{ 'notification.kpiWarnings' | translate }}</div>
                </th>
              </ng-container>
              <ng-container matColumnDef="All">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox color="primary" name="allKpis"
                    (change)="alertKpiAllCheckboxChanged($event)"
                    [checked]="alertConfig.kpiCpi === 2 && alertConfig.kpiBpi === 2 && alertConfig.kpiLpi === 2 && alertConfig.kpiApi === 2 && alertConfig.kpiChi === 2">
                    <div class="bold-text">{{ 'notification.all' | translate }}</div>
                  </mat-checkbox>
                </th>
              </ng-container>
              @for (kpiWarning of kpiWarnings; track kpiWarning) {
                <div>
                  <ng-container matColumnDef="{{ kpiWarning.name }}">
                    <th mat-header-cell *matHeaderCellDef>
                      <div class="flex-column">
                        <div class="kpi-warning-label">{{ kpiWarning.name }}</div>
                        <mat-checkbox color="primary" name="{{ kpiWarning.name }}"
                          (change)="alertCheckboxChanged($event, kpiWarning.value)"
                          [checked]="alertConfig[kpiWarning.value] === 2">
                        </mat-checkbox>
                      </div>
                    </th>
                  </ng-container>
                </div>
              }
              <tr mat-header-row *matHeaderRowDef="['KPIs', 'All']"></tr>
              <tr mat-header-row *matHeaderRowDef="['CPI', 'TPI', 'LPI', 'API', 'CHI']"></tr>
            </table>
          </div>
          <div class="flex-column checkbox-margin">
            <div class="flex-row">
              <mat-checkbox
                class="checkbox-min-width"
                color="primary"
                name="worstPart"
                (change)="alertCheckboxChanged($event, 'worstPart')"
                [checked]="alertConfig.worstPart === 2">
                <div class="bold-text">{{ 'notification.worstPart' | translate }}</div>
              </mat-checkbox>
            </div>
            <div class="flex-row">
              <mat-checkbox
                class="checkbox-min-width"
                color="primary"
                name="cpiCp"
                (change)="alertCheckboxChanged($event, 'cpiCp')"
                [checked]="alertConfig.cpiCp === 2">
                <div class="bold-text">{{ 'notification.cpiCp' | translate }}</div>
              </mat-checkbox>
            </div>
            <div class="flex-row">
              <mat-checkbox
                class="checkbox-min-width"
                color="primary"
                name="newBatchDeviation"
                (change)="alertCheckboxChanged($event, 'newBatchDeviation')"
                [checked]="alertConfig.newBatchDeviation === 2">
                <div class="bold-text">{{ 'notification.newBatchDeviation' | translate }}</div>
              </mat-checkbox>
            </div>
            <div class="flex-row">
              <mat-checkbox
                class="checkbox-min-width"
                color="primary"
                name="spc"
                (change)="alertCheckboxChanged($event, 'spc')"
                [checked]="alertConfig.spc === 2">
                <div class="bold-text">{{ 'notification.extendedSPC' | translate }}</div>
              </mat-checkbox>
            </div>
            <button mat-raised-button class="save-button" color="primary" (click)="saveAlertUserConfig()">{{ 'notification.save' | translate }}</button>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </mat-card>
</div>
